<template>
    <div>
        <div class="flex-space-around-no tabs">
            <div class="tab-item" :class="tabsIndex === index ? 'active' : 'reverse'" v-for="(tab, index) in tabs"
                :key="index" @click="handleTabs(index)">{{ tab }}</div>
        </div>
    </div>
</template>
<script>
import { array } from 'yargs';
import { Toast } from 'vant';
export default {
    props: {
        tabs: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            tabsIndex: 0
        }
    },
    methods: {
        handleTabs(index) {
            this.tabsIndex = index;
            // if(index === 1){
            //     Toast('暂未开赛')
            // }
            this.$emit('OnTabs', index)
            
        }
    }
}
</script>
<style lang="less" scoped>
@import '../../assets/style/global.less';

.tabs {
    text-align: center;

    // padding-top: 50px;
    .tab-item {
        font-size: 30px;
        font-weight: 700;
        color: #6D6E6F;
        padding: 16px 0 10px 0;
        width: 100%;
        position: relative;
        z-index: 5;

        &.active {
            color: #333333;
            background: white;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
            // padding-top: 15px;
        }

        &.reverse {
            background-image: linear-gradient(to bottom, #99C8E9 20%, #BBDAF0 60%, #EFF6FC 90%, #ffffff 100%);
            position: relative;
            top: 15px;
        }

        &:nth-child(1).reverse {
            border-top-left-radius: 8px;
        }

        &:nth-child(2).reverse {
            border-top-right-radius: 8px;
        }

        &:nth-child(1).reverse::after {
            content: '';
            width: 0;
            height: 0;
            border-top: 84px solid transparent;
            /*2.上边拉长就会变成直接三角形*/
            border-right: 40px solid white;
            // border-bottom: 0px solid yellow; /*1.底边去除就变成直角三角形*/
            // border-left: 40px solid white;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
            position: absolute;
            right: -4px;
            bottom: 0;
            z-index: 3;
        }

        &:nth-child(2).reverse::after {
            content: '';
            width: 0;
            height: 0;
            border-top: 84px solid transparent;
            /*2.上边拉长就会变成直接三角形*/
            // border-right: 50px solid red;
            // border-bottom: 0px solid yellow; /*1.底边去除就变成直角三角形*/
            border-left: 40px solid white;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
            position: absolute;
            left: -4px;
            bottom: 0;
            z-index: 3;
        }
    }
}
</style>